<template lang="pug">
  .belarus
    .title-img-wrap
      .img-bg
      img(
      src="@/assets/images/countries/belorus-min.png"
      )
      span {{ gettext('Белорусь') }}
    p.type-thin {{ gettext('Общие данные о стране') }}
    .content.one-grid
      div
        p {{ gettext('Славянский народ, проживающий на территории Беларуси, соседки Украины и России. Это трудолюбивая, аккуратная, толерантная нация с мягким характером. Белорусы по своей природе добры и внимательны, с удовольствием окажут помощь, если она вам потребуется, а также белорусы являются законопослушными гражданами.') }}
        p {{ gettext('По оценкам социологических исследований Беларуси, в настоящее время около 9% белорусов находятся в поисках работы за границей. Около 1,4 млн человек уже работают на иностранных предприятиях. Белорусы трудятся в разных странах, но в основном выбирают славянские страны, такие как Россия, Литва, Латвия, Эстония. Остальные трудоустраиваются в Польше, Германии, Финляндии, Норвегии. В перспективе работникам из Беларуси более интересно европейское направление для трудоустройства, поскольку сравнительная средняя зарплата в развитых странах Европы более конкурентоспособна.') }}
        p {{ gettext('В основном белорусы занимают рабочие специальности в секторах обслуживания, торговли, сельского хозяйства, транспорта, строительства и производства. Чаще занятость белорусских работников является сезонной, в которой они достаточно хорошо себя проявляют, в связи с чем наблюдается определенная закономерность ежегодного возвращения работников на те же места, к тем же работодателям.') }}
        p {{ gettext('Многие белорусы знают английский язык на базовом уровне, практически все владеют русским.') }}
        p {{ gettext('На рынке труда белорусы зарекомендовали себя с наилучшей стороны, как спокойные, трудолюбивые, серьёзные и ответственные работники, которые очень совестно выполняют свою работу.') }}
        router-link(:to="`/${getLanguage}/countries`")
          button.main-btn.bg-transparent.google
            | {{ gettext('See other countries') }}
</template>
<script>

import { gettext } from '@/services/TranslateHandler'
import { mapGetters } from 'vuex'
import mixin from '@/mixins'

export default {
  props: ['country'],
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo, sharedImg: document.location.origin + 'webapp/images/countries/belorus-min.png'})
  },
  name: 'Belarus',
  methods: {
    gettext: gettext
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Belarus | ' + gettext('Countries'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    }
  }
}
</script>

<style lang='scss' src='../country/styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/countries/belarus/index.vue